const tab_sections = {
    identity: 'ตัวตนและองค์กร',
    integrations: 'แอปและการเชื่อมต่อ',
    login_security: 'การเข้าสู่ระบบและความปลอดภัย',
    permissions: 'สิทธิ์และทรัพยากร',
    automation: 'ระบบอัตโนมัติและการตรวจสอบ',
    platform: 'แพลตฟอร์ม',
    overview: 'ภาพรวม',
    authentication: 'การพิสูจน์ตัวตน',
    authorization: 'การให้สิทธิ์',
    users: 'ผู้ใช้',
    developer: 'นักพัฒนา',
    tenant: 'ผู้เช่า',
};
export default Object.freeze(tab_sections);
